import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgrxFormControl } from '@ordersnproducts/modules/shared/models/ngrx-form-control/ngrx-form-control';
@Injectable()
export class FormControlMessageError {
  constructor(private translateService: TranslateService) {}

  getMessage(control: NgrxFormControl | UntypedFormControl): string {
    if (control.invalid && control.hasError('required') && control.touched) {
      return this.translateService.instant('forms.required');
    } else {
      return '';
    }
  }
}
